<div class="search--omni">
    <ul>
        <li class="search--omni__image">
            <customer-photo [classes]="'mvd_photo'"
                            [customerNumberId]="data.customerNumberId"
                            [credentialNumberId]="data.id"
                            [credentialNumber]="data.driverLicenseNumber"
                            [imageType]="data.imageType"
                            [jurisdictionCode]="data.jurisdictionDescription">
            </customer-photo>
            <div class="status--alert" title="Invalid Photo" *ngIf="data.driverImageStatusTypeId == driverImageStatusType?.Rejected?.id">
                <b></b>Invalid
            </div>
        </li>
        <li class="data--driver">
            <div><b>License Number:</b> {{ !isUserLecu && isRestrictedCustomer ? '******' : data.driverLicenseNumber }}</div>
            <div><b>Credential Number:</b> {{ data.id }}</div>
            <div><b>Voluntary Travel:</b> {{ data.voluntaryTravel }}</div>
            <div><b>Image Capture Date:</b> {{ data.driverImageCaptureDate | shortDate }}</div>

            <div *ngIf="data.endorsements?.length > 0">
                <b>Endorsements:</b>
                <div *ngFor="let a of data.endorsements">
                    {{ a.driverAttributeTypeDisplayValue }}
                </div>
            </div>

            <div *ngIf="data.restrictions?.length > 0">
                <b>Restrictions:</b>
                <ul class="list--bulleted">
                    <li *ngFor="let a of data.restrictions">
                        {{ a.driverAttributeTypeDisplayValue }}
                        <ng-container *ngIf="a.endDate">
                            ({{ a.effectiveDate | shortDate }} - {{ a.endDate | shortDate }})
                        </ng-container>
                    </li>
                </ul>
            </div>

            <div *ngIf="data.credentialAttributes?.length > 0">
                <b>Other Attributes:</b>
                <ul class="list--bulleted">
                    <li *ngFor="let a of data.credentialAttributes">
                        {{ a.driverAttributeTypeDisplayValue }}
                        <ng-container *ngIf="a.endDate">
                            ({{ a.effectiveDate | shortDate }} - {{ a.endDate | shortDate }})
                        </ng-container>
                    </li>
                </ul>
            </div>

            <div *ngIf="data.medicalAlerts?.length > 0">
                <b>Medical Alerts</b>
                <ul class="list--bulleted">
                    <li *ngFor="let a of data.medicalAlerts">
                        {{ a.customerindividualMedicalAlertTypeDisplayValue }}
                    </li>
                </ul>
            </div>
        </li>

        <li class="data--driver">
            <div><b>Cancelled Jurisdiction:</b> {{ data.outOfJurisdictionCredentialJurisdictionCode }}</div>
            <div><b>Cancelled Credential Number:</b> {{ data.outOfJurisdictionDriverLicenseNumber }}</div>
            <div><b>Status Reason:</b> {{ data.statusReason }}</div>
            <div><b>Expiration Adjustment Reason:</b> {{ data.expirationAdjustmentReason }}</div>
        </li>
    </ul>
</div>
